import { z } from 'zod';

export const itemStubSchema = z.object({
  id: z.number().int().positive(),
  parentId: z.number().int().positive().optional(),
  matched: z.boolean(),
  parentManagedByIntegration: z.boolean().optional(),
});

export const itemStubsResponseSchema = z.array(itemStubSchema);

export type ItemStubDTO = z.infer<typeof itemStubSchema>;
export type ItemStubsResponseDTO = z.infer<typeof itemStubsResponseSchema>;
